<template>
  <div class="text-right" style="padding-top:0.34rem">
    
  </div>
</template>


<script>
export default {
  name: "App",
  components: {
    // HelloWorld
  },
  data() {
    return {
      userInfo: []
    };
  },
  created() {
    document.getElementsByTagName("html")[0].style.margin = "0 16px 0 16px";
  },
  mounted() {
    this.$completes.complete("getUserInfo");
    window.getUserInfo = this.getUserInfo
    window['getUserInfo'] = (data) => {
      this.getUserInfo(data);
    }
  },
  methods: {
    getUserInfo(data) {
      this.userInfo = JSON.parse(data);
      let langs = this.userInfo.lang.substring(0, 2)
      let lang = this.userInfo.lang
      if (langs == 'zh') {
        if (lang == 'zh_TW' || lang == 'zh_HK') {
          this.$i18n.locale = 'tc'
        }
        else{
          this.$i18n.locale = 'zh'
        }
      }
      else if (langs == 'en') {
        this.$i18n.locale = 'en'
      }
      else if (langs == 'ar') {
        this.$i18n.locale = 'ar'
      }
      else if (langs == 'fr') {
        this.$i18n.locale = 'fr'
      }
      else {
        this.$i18n.locale = 'en'
      }
      document.title = this.$t('callingRules.callingRules01')
      document.querySelector('html').setAttribute('lang', this.$i18n.locale);
    },

  },

};

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html[lang="ar"] .text-right {
  /* direction: rtl; */
}


html[lang="ar"] .contentbox {
  text-align: right;
  direction: rtl;
}

html[lang="ar"] .title {
  direction: rtl;
}

body {
  opacity: 0.85;
}

.bg {
  background: #000000;
}

.box {
  position: relative;
  margin-top: 88px;
}

.title {
  font-size: 0.256rem;
  font-family: Mediums;
  color: #000000;
  padding-bottom: 0.247rem;
  font-weight: 600;
}

.contentbox {
  display: flex;
  /* padding: 0.299rem 0 0 0; */
}

.content {
  font-size: 0.239rem;
  font-family: Regulars;
  font-weight: 400;
  color: #000000;
}

</style>